import { useEffect } from 'react';

import { useRequestLoaderContext } from 'applications/GSP/app/providers/PrefetchProvider/hooks/useRequestLoaderContext';
import { useLazyGetApiLocalesByLocaleIdQuery } from 'applications/GSP/shared/api/gsp';
import { useDefaultLocale } from 'applications/GSP/shared/hooks/localization';

export const useGetTranslation = () => {
  const [{ isUserSettingsLoading }, setIsLoadingRequests] =
    useRequestLoaderContext();

  const [getTranslation] = useLazyGetApiLocalesByLocaleIdQuery();
  const localeId = useDefaultLocale();

  useEffect(() => {
    if (localeId && !isUserSettingsLoading) {
      setIsLoadingRequests(prev => ({
        ...prev,
        isTranslationLoading: true,
      }));

      getTranslation({ localeId }).finally(() => {
        setIsLoadingRequests(prev => ({
          ...prev,
          isTranslationLoading: false,
        }));
      });
    }
  }, [getTranslation, isUserSettingsLoading, localeId, setIsLoadingRequests]);
};
